export default {
    //Modal
    on_cancel_title: 'Cancelar',
    on_process_title: 'Confirmar'
}